"use client"

import { Facebook } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FacebookIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FacebookIcon = component(Icon)({ as: Facebook })
